import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../PageTemplate';
import * as api from '../../services/api';
import LoadingSpinner from '../../components/LoadingSpinner';
import ErrorMessage from '../../components/ErrorMessage';
import CaseStudyCard from '../../components/CaseStudyCard';

const AllCases = () => {
  const { t, i18n } = useTranslation();
  const [caseStudies, setCaseStudies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const breadcrumbs = [];

  useEffect(() => {
    const fetchCases = async () => {
      try {
        setLoading(true);
        const data = await api.getCaseStudies();
        setCaseStudies(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching case studies:', err);
        setError('Failed to load case studies');
      } finally {
        setLoading(false);
      }
    };

    fetchCases();
  }, []);

  const getCurrentLang = () => {
    return i18n.language === 'zh-CN' ? 'zh_CN' : 'en_US';
  };

  const lang = getCurrentLang();

  return (
    <PageTemplate 
      titleKey="nav.caseStudies"
      subtitleKey="pages.allCases.subtitle"
      breadcrumbs={breadcrumbs}
    >
      {loading && <LoadingSpinner />}
      {error && <ErrorMessage message={error} />}
      
      {!loading && !error && (
        <div className="content-card">
          <div className="cases-list">
            {caseStudies.map((caseStudy) => (
              <CaseStudyCard
                key={caseStudy._id || caseStudy.slug}
                clientName={caseStudy.client_name[lang]}
                industry={caseStudy.industry[lang]}
                challenge={caseStudy.challenge[lang]}
                results={caseStudy.results.map(result => result[lang])}
                image={caseStudy.image}
                slug={caseStudy.slug}
                featured={caseStudy.featured}
                keyResultsLabel={t('pages.allCases.keyResults')}
                readMoreLabel={t('mainContent.readMore')}
              />
            ))}
          </div>

          {caseStudies.length === 0 && (
            <p style={{ textAlign: 'center', color: '#666', padding: '40px' }}>
              {t('pages.allCases.noCases')}
            </p>
          )}
        </div>
      )}
    </PageTemplate>
  );
};

export default AllCases;
